import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT_SEND_EMAIL_CONTROL_REINTERVIEW,
  ENDPOINT_SEND_EMAIL_RESULT,
  ENDPOINT_SEND_EMAIL_SUBSCRIPTION,
} from './constants';

export function useEmailService() {
  const { backendPost } = Sebrae.useBackend();

  const sendEmailSubscriptionSvc = React.useCallback(
    (params) =>
      backendPost(`${ENDPOINT_SEND_EMAIL_SUBSCRIPTION}`, { ...params }),
    [backendPost],
  );

  const sendEmailReeinterview = React.useCallback(
    (id) => {
      return backendPost(
        `${ENDPOINT_SEND_EMAIL_CONTROL_REINTERVIEW}/${id}/send-email-reinterview`,
        id,
      );
    },
    [backendPost],
  );

  const sendEmailResultSvc = React.useCallback(
    (params) => backendPost(`${ENDPOINT_SEND_EMAIL_RESULT}`, { ...params }),
    [backendPost],
  );

  return {
    sendEmailSubscriptionSvc,
    sendEmailResultSvc,
    sendEmailReeinterview,
  };
}
